"use client";

import EndorsementList from "components/Modal/Endorsement/EndorsementList";

export interface EndorsementReviewDrawerContentV2Props {
  userId: string;
  skillId: string;
  skillName: string;
  publicProfile?: boolean;
}

export function EndorsementReviewDrawerContentV2({
  userId,
  skillId,
  skillName,
  publicProfile = true,
}: EndorsementReviewDrawerContentV2Props) {
  return (
    <EndorsementList
      userId={userId}
      skillId={skillId}
      skillName={skillName}
      publicProfile={publicProfile}
      showInlineHeader={false}
    />
  );
}
